/**
 * Códigos de error de dominio de gdp-api (serie 100X = sesión).
 *
 * Estaban repartidos como números sueltos por el Login, el slice de sesión y el interceptor; al añadir el
 * bloqueo de acceso (1009) hacía falta tocar los tres sitios a la vez, así que viven aquí.
 */

/** Usuario o contraseña incorrectos. */
export const ERROR_WRONG_USER_OR_PASSWORD = 1006;

/** El usuario del proveedor externo no corresponde a ningún usuario de TMC. */
export const ERROR_IDP_USER_NOT_MATCH = 1007;

/**
 * La cuenta existe y las credenciales son correctas, pero un administrador le ha bloqueado el acceso.
 *
 * Llega por dos caminos: al intentar entrar, y en cualquier petición de una sesión ya abierta cuando el
 * bloqueo ocurre con el usuario dentro (el back lo comprueba en cada validación de token).
 */
export const ERROR_USER_ACCESS_SUSPENDED = 1009;

/** La entidad pedida no existe; p. ej. la ficha de un usuario que se borró y se abre desde un enlace guardado. */
export const ERROR_NOT_FOUND = 102;

/** No hay sesión: el token no vale o ya no existe. */
export const ERROR_NO_SESSION = 1000;

/** Errores que dejan al usuario fuera y obligan a volver al login. */
export const SESSION_ENDING_ERROR_CODES = [ERROR_NO_SESSION, ERROR_USER_ACCESS_SUSPENDED];
